import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { createDate, handleDate } from "@/utils";
import { Box, Center, Checkbox, Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { Button } from "../button";
import { type PopUpProps } from "./popUp.type";

export const PopUp = ({ currentPopUp }: PopUpProps) => {
    const { imgUrl, style, liveHours, fromTo, postIdx } = currentPopUp;
    const { endDate } = fromTo;
    const { width, height } = style;
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    const [isPopUp, setIsPopUp] = useState(true);
    const [isExpired, setIsExpired] = useState(false);
    const getLiveHoursCookie = Cookies.get(`popupHidden_${postIdx}`);

    const handleClose = () => {
        setIsPopUp(false);
    };

    const handlePopUpCookie = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            const midnight = dayjs().endOf("day");
            Cookies.set(`popupHidden_${postIdx}`, "true", {
                expires: midnight.toDate(),
                sameSite: "None",
                secure: true,
            });
        }

        if (!e.target.checked) Cookies.remove(`popupHidden_${postIdx}`);
    };

    useEffect(() => {
        const { currentDateInfo } = createDate();
        const { newDateInfo } = handleDate(endDate);
        if (currentDateInfo === newDateInfo) setIsExpired(true);
    }, []);

    return (
        <Center
            position="relative"
            display={isPopUp && !getLiveHoursCookie && !isExpired ? "block" : "none"}
            w={isMobile ? "280px" : `${width}px`}
            h={isMobile ? "280px" : `${height}px`}
            sx={{
                "& > button": {
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    w: "16px",
                    h: "32px",
                    boxSizing: "border-box",
                    color: COLORS.white,
                    bgColor: COLORS.gray[500],
                },
            }}
        >
            <Button iconNamed="close" onClick={() => handleClose()} />
            <Box w="100%" h="100%" background={`url(${imgUrl}) no-repeat center / cover`} />
            <Flex
                color={COLORS.white}
                bgColor={COLORS.gray[500]}
                boxSizing="border-box"
                justifyContent="space-between"
                p="4px 12px"
                sx={{
                    ...FONT("pretendard", 14, 300),
                    "& > button": {
                        color: COLORS.white,
                        w: "auto",
                        h: "auto",
                        p: "0",
                        boxSizing: "border-box",
                        border: "none",
                    },
                }}
            >
                <Center columnGap="8px" as="label" cursor="pointer">
                    <Checkbox onChange={handlePopUpCookie} />
                    <Text>{liveHours}시간 동안 열지 않음</Text>
                </Center>
                <Button onClick={() => handleClose()}>창 닫기</Button>
            </Flex>
        </Center>
    );
};
